import ContainedIcon from '@/components/ContainedIcon';
import ZaiIconBase from '@/components/Icons/ZaiIcon';
import { SharedEndpointModelFamily } from '@/graphql';

import {
  mapIconSizeToSize,
  mapModelFamilyToIconColor,
  mapModelFamilyToIconContainerColor,
} from '../utils';
import { SharedEndpointIconProps, SharedEndpointIconSize } from './types';

function ZaiIcon({ size }: SharedEndpointIconProps) {
  const [containerSize, iconSize] = mapIconSizeToSize(size);

  return (
    <ContainedIcon
      size={containerSize}
      color={mapModelFamilyToIconContainerColor(SharedEndpointModelFamily.Zai)}
      borderRadius={size === SharedEndpointIconSize.XSMALL ? 6 : 8}
    >
      <ZaiIconBase
        sx={{
          width: iconSize,
          height: iconSize,
          color: mapModelFamilyToIconColor(SharedEndpointModelFamily.Zai),
        }}
      />
    </ContainedIcon>
  );
}

export default ZaiIcon;
